// ═══════════════════════════════════════════════════════════════════════
// track.js — tiny funnel-event tracker (fire-and-forget, never throws)
// ═══════════════════════════════════════════════════════════════════════
// Records product-funnel moments (first workspace, first log, checkout
// opened, paywall seen, statement uploaded …) via POST /api/events so the
// super-admin Overview can answer "where do signups drop off?" without a DB
// pull. Best-effort only: a failed call is swallowed and never affects the
// user-facing flow. The backend whitelists event names (events_routes.js).
import { API_BASE } from "./api";
import { getCurrentSession } from "../data/auth";

export async function track(event, props) {
  try {
    const session = await getCurrentSession();
    const token = session?.access_token;
    if (!token) return;
    await fetch(`${API_BASE}/api/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ event, props: props || {} }),
      keepalive: true,
    });
  } catch (_) {
    /* best-effort */
  }
}
